import querystring from 'querystring';
import _ from 'lodash';

function searchRequestMapper({
  status,
  userId,
  refHexaId,
  concessionId,
  appointmentDate,
  updatedAtMin,
  range,
  mode,
  creationDateMax,
  creationDateMin,
  entryStockDateMax,
  entryStockDateMin,
  registration,
  vin,
  registrationDate,
  clic2sell,
  clic2buy,
  sourceIds,
  groupId,
  verifAccess,
  recordTypeId,
  guaranteedPrice,
  brandName,
  modelName,
  sort,
  coverageDate,
  sale_offer_type,
  sourceId,
  nrmStatus,
  nrmRecordId,
  publicPos,
  recordStatus,
  cancelCases,
  carcheck,
  useExpectedDeliveryDateForNrmAndNrmHbs,
  stellaClub,
  pushToCoverage,
  pushToStockSale,
}) {
  return {
    ...(status !== undefined && status.join(',') && { recordStatus: status.join(',') }),
    ...(userId !== undefined && { buyerId: userId }),
    ...(refHexaId !== undefined && { refHexaId }),
    ...(concessionId !== undefined && { concessionId }),
    ...(appointmentDate !== undefined && { appointmentDate }),
    ...(updatedAtMin !== undefined && { updatedAtMin }),
    ...(creationDateMax !== undefined && { creationDateMax }),
    ...(creationDateMin !== undefined && { creationDateMin }),
    ...(entryStockDateMax !== undefined && { entryStockDateMax }),
    ...(entryStockDateMin !== undefined && { entryStockDateMin }),
    ...(registration !== undefined && { registration }),
    ...(vin !== undefined && { vin }),
    ...(registrationDate !== undefined && { registrationDate }),
    ...(clic2sell !== undefined && { clic2sell }),
    ...(clic2buy !== undefined && { clic2buy }),
    ...(sourceIds !== undefined && { sourceIds }),
    ...(groupId !== undefined && { groupId }),
    ...(verifAccess !== undefined && { verifAccess }),
    ...(recordTypeId !== undefined && { recordTypeId }),
    ...(guaranteedPrice !== undefined && { guaranteedPrice }),
    ...(brandName !== undefined && { brandName }),
    ...(modelName !== undefined && { modelName }),
    ...(sort?.[1] !== undefined && { sort: JSON.stringify(sort) }),
    ...(coverageDate !== undefined && { coverageDate }),
    ...(sale_offer_type !== undefined && { sale_offer_type }),
    ...(mode !== undefined && { searchMode: mode }),
    ...(sourceId !== undefined && { sourceId }),
    ...(nrmStatus !== undefined && nrmStatus.join(',') && { nrmStatus: nrmStatus.join(',') }),
    ...(recordStatus !== undefined && recordStatus.join(',') && { recordStatus: recordStatus.join(',') }),
    ...(nrmRecordId !== undefined && { nrmRecordId }),
    ...(publicPos !== undefined && { publicPos }),
    ...(cancelCases !== undefined && { cancelCases: Number(cancelCases) }),
    ...(carcheck !== undefined && { carcheck }),
    ...(stellaClub && { stellaClub }),
    ...(useExpectedDeliveryDateForNrmAndNrmHbs !== undefined && { useExpectedDeliveryDateForNrmAndNrmHbs }),
    ...(pushToCoverage !== undefined && { pushToCoverage }),
    ...(pushToStockSale !== undefined && { pushToStockSale }),
    range: JSON.stringify(range),
  };
}
export class RecordApi {
  constructor(api) {
    this.api = api;
  }

  async get(recordId) {
    if (recordId !== 0) {
      const { data } = await this.api('getRecordDetails', { recordId });
      return data;
    }
    return [];
  }

  async search({
    status,
    userId,
    refHexaId,
    concessionId,
    appointmentDate,
    updatedAtMin,
    range,
    mode,
    creationDateMax,
    creationDateMin,
    entryStockDateMax,
    entryStockDateMin,
    registration,
    vin,
    registrationDate,
    clic2sell,
    clic2buy,
    sourceIds,
    groupId,
    verifAccess,
    recordTypeId,
    guaranteedPrice,
    brandName,
    modelName,
    sort,
    sourceId,
    nrmStatus,
    nrmRecordId,
    publicPos,
    recordStatus,
    cancelCases,
    carcheck,
    useExpectedDeliveryDateForNrmAndNrmHbs,
    stellaClub,
    pushToCoverage,
    pushToStockSale,
  }) {
    const query = searchRequestMapper({
      status,
      userId,
      refHexaId,
      concessionId,
      appointmentDate,
      updatedAtMin,
      range,
      mode,
      creationDateMax,
      creationDateMin,
      entryStockDateMax,
      entryStockDateMin,
      registration,
      vin,
      registrationDate,
      clic2sell,
      clic2buy,
      sourceIds,
      groupId,
      verifAccess,
      recordTypeId,
      guaranteedPrice,
      brandName,
      modelName,
      sort,
      sourceId,
      nrmStatus,
      nrmRecordId,
      publicPos,
      recordStatus,
      cancelCases,
      carcheck,
      useExpectedDeliveryDateForNrmAndNrmHbs,
      stellaClub,
      pushToCoverage,
      pushToStockSale,
    });
    const response = await this.api('searchRecord', null, query);
    const { headers } = response;
    let { data } = response;

    if (!Array.isArray(data)) data = [data];

    let totalCount = 0;
    const contentRange = headers['content-range'];
    if (contentRange) {
      totalCount = parseInt(contentRange.split('/')[1], 10);
    }

    return {
      records: data.map((r) => ({ ...r, id: r.recordId })),
      totalCount,
    };
  }

  async getUpdateDate(recordId) {
    const { updateAt } = (await await this.api('getUpdateAt', { recordId })).data;
    return updateAt?.date;
  }

  async updateStatus(recordId, status) {
    return (
      await this.api('updateStatus', {
        recordId,
        status,
      })
    ).data;
  }

  updateRecordData(recordId, data) {
    return this.api('updateRecord', { recordId }, null, JSON.stringify(data));
  }

  getVehiculeByVin(vin, country, registrationDate = null, language, methode = null) {
    const queryData = {
      refresh: true,
      identMethod: 'V',
      origin: 'autobizCarcheck',
    };
    if (registrationDate !== null) {
      queryData.registrationDate = registrationDate;
    }
    if (methode === 'decodeVin') {
      queryData.meta = true;
      queryData.identMethod = 'R';
    }

    if (country === 'BE') queryData.language = language;
    return this.api('getVehiculeByVin', { vin, country }, queryData);
  }

  getVehiculeByReg(registration, country, language) {
    const queryData = {
      refresh: true,
      origin: 'autobizCarcheck',
    };
    if (country === 'BE') queryData.language = language;
    return this.api('getVehiculeByReg', { registration, country }, queryData);
  }

  async getPreference() {
    return (await this.api('getPreference')).data;
  }

  async getVersionDetails(versionId, dateMecYear, dateMecMonth, mileage) {
    if (!versionId || !dateMecYear || !mileage) throw new Error('api_error_versions_quotation_unkown');

    let parameters = dateMecMonth ? `month=${dateMecMonth}` : '';

    parameters += parameters ? '&origin=autobizCarcheck' : 'origin=autobizCarcheck';

    const response = await this.api(
      'getQuotation',
      {
        versionId,
        dateMecYear,
        mileage,
      },
      querystring.parse(parameters),
    );

    return response.data;
  }

  async pushToDm(recordId, profile) {
    const { id } = (await this.api('postDm', { recordId }, null, JSON.stringify({ profile }))).data;
    return id;
  }

  async postRecord(data) {
    const record = { ...data };
    const { recordId } = (
      await this.api('postRecord', { client: 'carcheck' }, null, JSON.stringify(record), {
        'Content-Type': 'application/json',
      })
    ).data;
    return recordId;
  }

  async updateAppointment(recordId, { appointmentDateTime, concessionId }) {
    await this.api('updateAppointment', { recordId }, null, JSON.stringify({ appointmentDateTime, concessionId }), {
      'Content-Type': 'application/json',
    });
  }

  // offers
  async getOffer(recordId, type) {
    let { data } = await this.api('getOffer', { recordId, type });
    if (!Array.isArray(data)) data = [data];
    return data;
  }

  async getPartnerOffer(recordId) {
    let { data } = await this.api('getPartnerOffer', { recordId });
    if (!Array.isArray(data)) data = [data];
    return data;
  }

  async postTrade(recordId) {
    return (await this.api('postTrade', { recordId })).data;
  }

  async postAnnonceAt(body) {
    const formatBody = body;
    Object.entries(formatBody).map(([info, value]) => {
      if (value === true) formatBody[info] = 1;
      if (value === false) formatBody[info] = 0;
      return formatBody;
    });
    await this.api('postSale', null, null, JSON.stringify(formatBody));
  }

  async postPartner(partner, comment, autobizTradeId) {
    return (
      await this.api(
        'postPartner',
        null,
        null,
        JSON.stringify({
          vehicle: `/api/vehicles/${autobizTradeId}`,
          partner: `/api/partners/${partner}`,
          comment,
        }),
      )
    ).data;
  }

  async putPartnerOffer(partnerOfferId, is_accepted) {
    return (await this.api('putPartnerOffer', { partnerOfferId }, null, JSON.stringify({ is_accepted }))).data;
  }

  async getPickupSites() {
    const { data } = await this.api('getPickupSites');
    return data;
  }

  async postPickupSites(withdrawalSiteId, withdrawalSiteName, billingSite, auctionGroupId, idPartnerOffer) {
    return (
      await this.api(
        'postPickupSites',
        null,
        null,
        JSON.stringify({
          withdrawalSiteId,
          withdrawalSiteName,
          billingSite,
          auctionGroupId,
          idPartnerOffer,
        }),
      )
    ).data;
  }

  async getSale(type, recordId) {
    return (
      await this.api('getSale', {
        type,
        recordId,
      })
    ).data;
  }

  async postPricing(recordId, data) {
    const { id } = (await this.api('postOffer', { recordId }, null, JSON.stringify(data))).data;
    return id;
  }

  async getVersions(filters) {
    const { makeId, modelId, dateOfRelease, country } = filters;
    const apiFilters = { ...filters };
    if (dateOfRelease && typeof dateOfRelease === 'string') {
      delete apiFilters.dateOfRelease;
      const year = _.parseInt(dateOfRelease.substring(0, 4), 10);
      if (_.inRange(year, 1970, new Date().getFullYear())) {
        apiFilters.year = year;
      }
      const month = dateOfRelease.substring(5, 7);
      if (month && month.length === 2) {
        apiFilters.month = month;
      }
    }
    apiFilters.country = country;
    apiFilters.regOk = false;
    if (!apiFilters.engine) delete apiFilters.engine;
    const params = querystring.stringify(apiFilters);

    let result = (await this.api('getVersions', { makeId, modelId }, querystring.parse(params))).data;
    if (!Array.isArray(result)) result = [result];
    return result;
  }

  async getPricingHistory(recordId, tradeType) {
    const parameters = `filter={"trackTypeId":${tradeType},"recordId":${recordId}}`;
    let result = (await this.api('getPricingHistory', { recordId }, querystring.parse(parameters))).data;
    if (!Array.isArray(result)) result = [result];
    return result;
  }

  async postFordCoverage(recordId, data) {
    const res = await this.api('postReferencePricing', { recordId }, null, JSON.stringify(data));
    return {
      status: res.status,
      data: res.data,
    };
  }

  async getGroupUserInfos() {
    const infos = (await this.api('getGroupUserInfos')).data;
    return infos;
  }

  async putSupervisorInfos(recordId, data) {
    const res = (await this.api('putSupervisorInfos', { recordId }, null, JSON.stringify(data))).data;
    return res;
  }

  async getConfigurationsDetails(id) {
    const res = (await this.api('getConfigurationsDetails', { id })).data;
    return res;
  }

  async getSource(sourceId, params = {}) {
    const res = (await this.api('getSourceInfo', { sourceId }, params)).data;
    const sourceInfo = res;
    sourceInfo.source = sourceInfo.source === 'Easyreprise' ? 'carcheck' : sourceInfo.source;
    sourceInfo.source = sourceInfo.source === 'Mobile.de' ? 'mobile' : sourceInfo.source;
    sourceInfo.source = sourceInfo.source.toLowerCase();
    return sourceInfo;
  }

  async getBuyers(params = null) {
    if (!params) return null;
    return (await this.api('getBuyersBySourceId', null, params)).data;
  }

  async putSales(saleId, data) {
    const res = (await this.api('putSale', { saleId }, null, JSON.stringify(data))).data;
    return res;
  }

  async putOffer(offerId, data) {
    return (await this.api('putOffer', { offerId }, null, JSON.stringify(data))).data;
  }

  async postBee2Link(recordId, data) {
    return (await this.api('postBee2Link', { recordId }, null, JSON.stringify(data))).data;
  }

  async lockPricing(recordId) {
    const res = await this.api('lockPricing', { recordId });
    return res.data;
  }

  async unlockPricing(recordId) {
    await this.api('unlockPricing', { recordId });
  }

  async postCounterInspection(inspectionInitialRecordId, recordId) {
    const res = (
      await this.api('postCounterInspection', { recordId }, null, JSON.stringify({ inspectionInitialRecordId }))
    ).data;
    return res;
  }

  async removeCounterInspection(recordId) {
    const res = (await this.api('removeCounterInspection', { recordId }, null)).data;
    return res;
  }

  async searchSupervisorCoverageRequest({
    status,
    userId,
    refHexaId,
    concessionId,
    appointmentDate,
    updatedAtMin,
    range,
    mode,
    creationDateMax,
    creationDateMin,
    registration,
    registrationDate,
    hbs,
    sourceId,
    verifAccess,
    groupId,
    recordTypeId,
    guaranteedPrice,
    brandName,
    modelName,
    sort,
    coverageDate,
    sale_offer_type,
  }) {
    const query = searchRequestMapper({
      status,
      userId,
      refHexaId,
      concessionId,
      appointmentDate,
      updatedAtMin,
      range,
      mode,
      creationDateMax,
      creationDateMin,
      registration,
      registrationDate,
      hbs,
      sourceId,
      groupId,
      verifAccess,
      recordTypeId,
      guaranteedPrice,
      brandName,
      modelName,
      sort,
      coverageDate,
      sale_offer_type,
    });
    const response = await this.api('getCoverageRequest', null, query);
    const { headers } = response;
    let { data } = response;

    if (!Array.isArray(data)) data = [data];

    let totalCount = 0;
    const contentRange = headers['content-range'];
    if (contentRange) {
      totalCount = parseInt(contentRange.split('/')[1], 10);
    }

    return {
      records: data.map((r) => ({ ...r, id: r.recordId })),
      totalCount,
    };
  }

  async getUserFeeds() {
    const res = (await this.api('getUserFeed')).data;
    return res;
  }

  createInspectionVersion(recordId, data) {
    return this.api('createInspectionVersion', { recordId }, null, data.comment !== null ? JSON.stringify(data) : '');
  }

  getExternalRef(recordId) {
    return this.api('getExternalRef', { recordId });
  }

  async postCounterOffer(amount, offerId, userId, saleId) {
    return (
      await this.api(
        'postCounterOffer',
        null,
        null,
        JSON.stringify({
          is_counter_offer: true,
          amount: parseFloat(amount),
          original_offer: offerId,
          user: userId,
          sale: saleId,
        }),
      )
    ).data;
  }

  async putCounterOffer(uuid, userId, accepted) {
    return (
      await this.api(
        'putCounterOffer',
        { uuid },
        null,
        JSON.stringify({
          userId,
          accepted,
        }),
      )
    ).data;
  }

  async generatePurchaseOrder(id) {
    return (await this.api('createPurchaseOrder', { id })).data;
  }

  async postReportAi(recordId) {
    await this.api('postReportAi', { recordId });
  }

  async retriveHistovecInfo(recordId, data) {
    return (await this.api('retriveHistovecInfo', { recordId }, null, JSON.stringify(data))).data;
  }

  async postGuaranteedPrice(recordId) {
    const res = await this.api('postGuaranteedPrice', { recordId });
    return res;
  }

  async getHistoryNrm(nrmRecord, nrmHistoryTypeId = 1) {
    const parameters = `filter={"nrmRecordId":"${nrmRecord}","nrmHistoryTypeId":"${nrmHistoryTypeId}"}`;
    const sort = JSON.stringify(['id', 'DESC']);
    const { data } = await this.api('getHistoryNrm', null, { ...querystring.parse(parameters), sort });
    return data;
  }

  async putNrmStatus(recordId, nrmStatusId) {
    return (await this.api('putNrmStatus', { recordId, nrmStatusId })).data;
  }

  async putMaintainedGuanranteed(maintainedGuarantee, recordId) {
    await this.api(
      'putMaintainedGuanranteed',
      { recordId },
      null,
      JSON.stringify({ maintainedGuaranteedAccepted: maintainedGuarantee }),
    );
  }

  async createCounterInspection(recordId) {
    const data = { recordId };
    return (await this.api('createCounterInspection', null, null, JSON.stringify(data))).data;
  }

  async putFirmValuation(recordId, data) {
    return (await this.api('putFirmValuation', { recordId }, null, JSON.stringify(data))).data;
  }

  async putNCOrderLink(nrmRecordId, data) {
    return (await this.api('putNCOrderLink', { nrmRecordId }, null, JSON.stringify(data))).data;
  }

  async getAutotelex(registration, data) {
    return (
      await this.api(
        'getVehiculeByRegAutotelex',
        {
          registration,
        },
        data,
      )
    ).data;
  }

  async createExternalProvider(recordId, json) {
    return (await this.api('createExternalProvider', { recordId, providerId: 1 }, null, JSON.stringify(json))).data;
  }

  async getAutotelexVersions(recordId, data) {
    const res = (await this.api('getExternalProvider', { recordId }, data)).data;
    if (res?.id > 0) return res?.body?.versions;
    return [];
  }

  async refuseOffersBySale(id) {
    const res = (await this.api('refuseOffersBySale', { id })).data;
    return res;
  }

  async getPackageMonkGenerate(recordId) {
    const result = await this.api('getPackageMonkGenerate', { recordId });
    return result;
  }

  async updateBuyerExpertise(recordId, body) {
    const res = (await this.api('putBuyerExpertise', { recordId }, null, JSON.stringify(body))).data;
    return res;
  }
}
